import classNames from 'classnames';
import { forwardRef, createElement } from 'react';

var heading = "Heading-module_heading__36-5e";
var large = "Heading-module_large__5Gcxo";
var medium = "Heading-module_medium__zEpRa";
var small = "Heading-module_small__nPLFk";
var xsmall = "Heading-module_xsmall__8bRKc";
var Heading_module = {"heading":"Heading-module_heading__36-5e","large":"Heading-module_large__5Gcxo","medium":"Heading-module_medium__zEpRa","small":"Heading-module_small__nPLFk","xsmall":"Heading-module_xsmall__8bRKc"};

var styles = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: Heading_module,
  heading: heading,
  large: large,
  medium: medium,
  small: small,
  xsmall: xsmall
});

const Heading = forwardRef(({ id, children, level, size, className, ...otherProps }, ref) => {
    const headingstyle = classNames(`${heading} ${styles[size]}`, className);
    return createElement(`h${level}`, { ref, id, className: headingstyle, ...otherProps }, children);
});
Heading.displayName = "Heading";

export { Heading };
